import { render, staticRenderFns } from "./signature-approve.vue?vue&type=template&id=6c7ec0d8&scoped=true&"
import script from "./signature-approve.vue?vue&type=script&lang=js&"
export * from "./signature-approve.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7ec0d8",
  null
  
)

export default component.exports